<template>
	<div>
		<div class="content">
			<h2>消息中心</h2>
			<ul class="content_ul">
				<li v-for="(item,index) in list" :key="index">
					<span
						style="display:inline-block;;width:60%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;cursor:pointer;"
						@click="topage(item)"
					>
						【{{ item.noteType }}】 {{ item.noteTitle }}-{{
							item.communityName
						}}
					</span>
					<span
						style="float:right;cursor:pointer;"
						@click="
							stopModel = true
							delId = item.id
						"
					>
						删除
					</span>
					<span style="float:right;margin-right:18px;">
						{{ item.pubTime }}
					</span>
					<span
						style="float:right;display:inline-block;height:8px;width:8px;border-radius:4px;background-color:#d62f2f;margin-top:18px;margin-right:3px;"
						v-show="item.readStatus == 1"
					>
					</span>
				</li>
			</ul>
			<div style="margin-top:20px;" v-if="total > 0">
				<div slot style="display: inline-block;line-height: 30px;">
					共 {{ total }} 条记录 第 {{ pageNo }}/{{ allpage }} 页
				</div>
				<Page
					:total="total"
					show-elevator
					:page-size="pageSize"
					@on-change="pagechange"
				>
					<!-- <div slot>
                        共 {{total}} 条记录  第 {{pageNo}}/{{allpage}} 页         
                </div> -->
				</Page>
			</div>
		</div>
		<Modal
			v-model="stopModel"
			title="提示!"
			@on-ok="stopok"
			@on-cancel="
				stopModel = false
				delId = ''
			"
		>
			<p>确认删除此条通知？</p>
		</Modal>
	</div>
</template>
<script>
import { admin } from '@/api/admin'
import { hasbtn } from '@/utils/commondata'
export default {
	name: 'HelloWorld',
	props: {
		msg: String
	},
	data() {
		return {
			total: 0,
			pageSize: 10,
			pageNo: 1,
			allpage: 1,
			delId: '',
			stopModel: false,
			list: []
		}
	},
	mounted() {
		this.getnoticeList()
	},
	methods: {
		pagechange(n) {
			this.pageNo = n
			this.getnoticeList()
		},
		getnoticeList() {
			admin
				.getnoticeList({ pageNo: this.pageNo, pageSize: this.pageSize })
				.then(res => {
					if (res.data.success == true) {
						if (res.data.result) {
							this.list = res.data.result.records
							this.total = res.data.result.total
							this.allpage = res.data.result.pages
								? res.data.result.pages
								: 1
						}
					}
				})
		},
		stopok() {
			this.delnotice(this.delId)
		},
		delnotice(id) {
			admin.delnotice(id).then(res => {
				if (res.data.success == true) {
					this.pageNo = 1
					this.getnoticeList()
				} else {
					this.$Message.error(res.data.message)
					return
				}
			})
		},
		topage(item) {
			const {noteType:type , id, noteTitle:title , majorId:taskId,communityName} = item;
			let path = ''
			if (type == '实勘任务') {
				//悦居经纪人
				path = '/MyHome/Index' //我的实勘任务
			} else if (type == '房源发布') {
				//悦居经纪人
				path = '/Mh/Index' //我的房源
			} else if (type == '交易流程') {
				//悦居经纪人
				path = '/easy/list' //我的交易
			} else if (
				type == '数据审核' &&
				sessionStorage.roleCode == 'yuejuStoreManager'
			) {
				//悦居店长
				path = '/long/Index' //房源发布审核
			} else if (
				type == '数据审核' &&
				sessionStorage.roleCode == 'dataChecker' &&
				title == '房源签约审核'
			) {
				//数据审核员
				path = '/Signin/Index' //房源发布审核
			} else if (
				type == '数据审核' &&
				sessionStorage.roleCode == 'dataChecker' &&
				title == '实勘任务退回审核'
			) {
				path = '/Audit' //实勘退回
			}else if(type == "审批情况"){
				path = '/loupanManagement/list';
			}
			if (hasbtn(this.$router.options.routes[1].children, path)) {
				admin.changenoticeStatue(id).then(res => {});
				if(type == '审批情况'){
					this.$router.push({ path: path, query: { companyName: communityName } })
				}else{
					this.$router.push({ path: path, query: { taskId: taskId } })
				}
			} else {
			}
		}
	}
}
</script>
<style scoped>
.content {
	width: 800px;
	margin: 40px auto;
}
h2 {
	margin-bottom: 40px;
}
.content_ul > li {
	line-height: 50px;
}
</style>

